<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" icon="plus" @click="addVisible = true">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiCrowdtypeQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="人群种类查询">
				<div style="display: flex;justify-content: space-between;">
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 140px;">人群种类名称：</div>
						<a-input v-model="query.crowdtypeName" style="width: 100%;" placeholder="请输入名称关键字查询" />
					</div>
					<div style="width: 30%;display: flex;align-items: center;justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiCrowdtypeQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		
		<div class="qinang-card">
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="crowdtypeId"
				:loading="tableLoading" :pagination="false">
				<span slot="crowdtypeName" slot-scope="crowdtypeName">
					<a-button type="link" @click="edit(crowdtypeName)" >{{crowdtypeName.crowdtypeName}}</a-button>
				</span>
		
				<span slot="crowdtypeState" slot-scope="crowdtypeState">
					<span v-if="crowdtypeState == 2">禁用</span>
					<span v-if="crowdtypeState == 3">启用</span>
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->
		<a-modal title="添加" width="600px" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="addHandleCancel" :maskClosable="false" :keyboard="false">
			<a-form-model ref="addRuleForm" :model="addForm" :label-col="{span: 6}" :wrapper-col="{span: 12}" :rules="addRules">
				<a-form-model-item label="人群种类名称" has-feedback prop="crowdtypeName">
					<a-input v-model="addForm.crowdtypeName" />
				</a-form-model-item>
				<a-form-model-item label="状态" has-feedback prop="crowdtypeState">
					<a-radio-group name="crowdtypeState" v-model="addForm.crowdtypeState">
					    <a-radio :value="3">启用</a-radio>
						<a-radio :value="2">禁用</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="备注" has-feedback prop="remarks">
					<a-textarea placeholder="在这里输入备注" :rows="4" v-model="addForm.remarks" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
		<!-- 修改弹窗 -->
		<a-modal title="修改" width="600px" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="editHandleCancel" :maskClosable="false" :keyboard="false">
			<a-form-model ref="editRuleForm" :model="editForm" :label-col="{span: 6}" :wrapper-col="{span: 12}" :rules="addRules">
				<a-form-model-item label="人群种类名称" has-feedback prop="crowdtypeName">
					<a-input v-model="editForm.crowdtypeName" />
				</a-form-model-item>
				<a-form-model-item label="状态" has-feedback prop="crowdtypeState">
					<a-radio-group name="crowdtypeState" v-model="editForm.crowdtypeState">
					    <a-radio :value="3">启用</a-radio>
						<a-radio :value="2">禁用</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="备注" has-feedback prop="remarks">
					<a-textarea placeholder="在这里输入备注" :rows="4" v-model="editForm.remarks" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				
				query: {
					page: 1,
					size: 10,
					total: 0,
					parentId: 0,
					crowdtypeName: '',
				},
			
				tableData: [],
				tableColumns: [{
						title: '人群种类ID',
						dataIndex: 'crowdtypeId',
						key: 'crowdtypeId',
						align: 'center'
					},
					{
						title: '人群种类名称',
						key: 'crowdtypeName',
						align: 'center',
						scopedSlots: {
							customRender: 'crowdtypeName'
						}
					},
					{
						title: '状态',
						dataIndex: 'crowdtypeState',
						key: 'crowdtypeState',
						align: 'center',
						scopedSlots: {
							customRender: 'crowdtypeState'
						}
					},
					{
						title: '备注',
						dataIndex: 'remarks',
						key: 'remarks',
						align: 'center',
					},

				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					crowdtypeName: '',
					crowdtypeState: 3,
					remarks: '',
				},
				addRules: {
					crowdtypeName: [{ required: true, message: '人群种类名称不能为空', trigger: 'blur' }],
					crowdtypeState: [{ required: true, message: '请选择状态', trigger: 'blur' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					crowdtypeId: '',
					crowdtypeName: '',
					crowdtypeState: 3,
					remarks: '',
				},
				// 修改弹窗-end
			};
		},
		methods: {
			async apiCrowdtypeQueryList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCrowdtypeQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiCrowdtypeQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiCrowdtypeQueryList()
			},
		
			//添加弹窗事件-开始
			async apiCrowdtypeAdd() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCrowdtypeAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiCrowdtypeQueryList()
					this.addConfirmLoading = false
					this.addVisible = false
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiCrowdtypeAdd()
					} else {
					  return false;
					  this.addConfirmLoading = true
					}
				});
				
			},
			addHandleCancel() {
				this.addVisible = false
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			edit(item){
				this.editForm = item
				this.editVisible = true
			},
			async apiCrowdtypeEdit() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCrowdtypeEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.editRuleForm.resetFields();
					this.apiCrowdtypeQueryList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiCrowdtypeEdit()
					} else {
					  return false;
					  this.editConfirmLoading = true
					}
				});
				
			},
			editHandleCancel() {
				this.editVisible = false
			},
			//修改弹窗事件-结束
			
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.crowdtypeId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: this.tableSelectedRows.crowdtypeName,
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiCrowdtypeDel()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiCrowdtypeDel() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCrowdtypeDel, {crowdtypeId: this.tableSelectedRows.crowdtypeId});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiCrowdtypeQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			tableEdit() {
				if(this.tableSelectedRows.crowdtypeId > 0) {
					this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			}
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'radio',
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0];
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiCrowdtypeQueryList()
		}
	};
</script>

<style scoped>
	.main-info {
		background-color: #fff;
	}
	

</style>
